'use client';

import { useEffect, useState } from 'react';
import { asText, DateField } from '@prismicio/client';

import { Typography } from '@preventx/oxygen';
import { toShortDate } from '@preventx/calcium';
import { defaultEnv } from '@preventx/prismic-services';

// Contexts
import { useReusableContentContext } from '@/context/ReusableContentProvider';

// Constants
import { DateReplacementKey } from '@/constants/configuration';

// Content
import fallback from '@/content/fallback.json';

type LastReviewedHeadlineProps = {
  lastReviewed: DateField;
};

export const LastReviewedHeadline = ({
  lastReviewed,
}: LastReviewedHeadlineProps) => {
  const { reusableContent } = useReusableContentContext();

  const [label, setLabel] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!lastReviewed) {
      return;
    }

    const lastReviewedText = reusableContent?.last_reviewed
      ? asText(reusableContent.last_reviewed)
      : fallback['last-reviewed-label'];

    setLabel(
      lastReviewedText.replace(
        DateReplacementKey,
        toShortDate(lastReviewed, defaultEnv.CountryCode) ?? '',
      ),
    );
  }, [reusableContent]);

  if (!label) {
    return null;
  }

  return (
    <Typography component="p">
      <Typography component="small">{label}</Typography>
    </Typography>
  );
};
